import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./app.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ClerkProvider } from "@clerk/clerk-react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "components/common/store/store";

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || "";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={clerkPubKey}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </ClerkProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
